document.addEventListener('DOMContentLoaded', initFilters);

function initFilters(){
  attachFilterListeners(document);
  // set up mobile drawer buttons
  const openBtn=document.getElementById('MobileFiltersToggle');
  console.log('openBtn', openBtn);
  const closeBtn=document.getElementById('MobileFiltersClose');
  if(openBtn){openBtn.addEventListener('click',function(e){e.preventDefault();drawerOpen();});}
  if(closeBtn){closeBtn.addEventListener('click',function(e){e.preventDefault();drawerClose();});}
}

// Helper to add is-transitioning class for the duration of a CSS transition
function prepareTransition(el){
  if(!el) return;
  // remove in case it was left for some reason
  el.classList.remove('is-transitioning');

  // Check if the element actually has a transition duration > 0
  const style = window.getComputedStyle(el);
  const durations = style.transitionDuration.split(',').map(d => parseFloat(d) || 0);
  const maxDuration = Math.max(...durations);

  if(maxDuration === 0){
    return; // no transition to wait for
  }

  const removeClass = () => {
    el.classList.remove('is-transitioning');
    ['transitionend','webkitTransitionEnd','oTransitionEnd'].forEach(evt => {
      el.removeEventListener(evt, removeClass);
    });
  };

  ['transitionend','webkitTransitionEnd','oTransitionEnd'].forEach(evt => {
    el.addEventListener(evt, removeClass, { once: true });
  });

  el.classList.add('is-transitioning');
  // Force reflow so the browser picks up the class addition before the transition starts
  void el.offsetWidth;
}

function attachFilterListeners(scope){
  scope.querySelectorAll('.filter-checkbox').forEach(cb=>{
    cb.addEventListener('change', handleFilterChange);
  });
}

function handleFilterChange(e){
  const li  = this.closest('.filter-item');
  if(!li) return;

  const url = this.checked ? li.dataset.hrefAdd : li.dataset.hrefRemove;
  if(!url) return;

  e.preventDefault();
  ajaxLoad(url, ()=> attachFilterListeners(document));
  drawerClose();
}

// ---------------- existing ajax helper ----------------
function ajaxLoad(url, afterSuccess){
  showLoadingState();
  fetch(url)
    .then(r=>r.text())
    .then(html=>{
      const doc = new DOMParser().parseFromString(html,'text/html');
      document.querySelector('#CollectionAjaxContent').innerHTML = doc.querySelector('#CollectionAjaxContent').innerHTML;
      document.querySelector('.sidebar-element').innerHTML        = doc.querySelector('.sidebar-element').innerHTML;
      updateURL(url);
      afterSuccess();
    })
    .catch(err=>console.error('filter ajax',err))
    .finally(hideLoadingState);
}

// Function to show loading state
function showLoadingState() {
  const content = document.querySelector('#CollectionAjaxContent');
  if (content) {
    content.style.opacity = '0.5';
    content.style.pointerEvents = 'none';
  }
}

// Function to hide loading state
function hideLoadingState() {
  const content = document.querySelector('#CollectionAjaxContent');
  if (content) {
    content.style.opacity = '1';
    content.style.pointerEvents = 'auto';
  }
}

// Function to update URL without page refresh
function updateURL(url) {
  if (window.history && window.history.pushState) {
    window.history.pushState({}, '', url);
  }
}

// Function to update active filter state
function updateActiveFilterState(clickedFilter) {
  // Remove active class from all filters
  filterElements.forEach(function(filter) {
    filter.classList.remove('active');
  });
  
  // Add active class to clicked filter
  clickedFilter.classList.add('active');
}

// Function to reinitialize components that might need it
function reinitializeComponents() {
  // Reinitialize any carousels, tooltips, or other components
  if (typeof window.initCarousels === 'function') {
    window.initCarousels();
  }
  
  // Reinitialize any lazy loading
  if (typeof window.lazyLoad === 'function') {
    window.lazyLoad();
  }
  
  // Trigger any custom events for other scripts
  const event = new CustomEvent('collectionContentUpdated');
  document.dispatchEvent(event);
}

// Handle browser back/forward buttons
window.addEventListener('popstate', function() {
  // Reload the current page content based on the URL
  const currentUrl = window.location.href;
  
  showLoadingState();
  
  fetch(currentUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('#CollectionAjaxContent');
      
      if (newContent) {
        const currentContent = document.querySelector('#CollectionAjaxContent');
        if (currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
        reinitializeComponents();
      }
    })
    .catch(error => {
      console.error('Error handling popstate:', error);
    })
    .finally(() => {
      hideLoadingState();
    });
});

let outsideClickHandler=null;
let overlayEl=null;

function drawerOpen(){const drawer=document.querySelector('.sidebar-element.hide-desktop');if(drawer){
  prepareTransition(drawer);
  drawer.classList.add('open');
  document.body.classList.add('drawer-open');

  // create transparent overlay to block interaction with page content
  overlayEl=document.createElement('div');
  overlayEl.className='drawer-overlay';
  document.body.appendChild(overlayEl);

  // attach one-time outside click listener
  outsideClickHandler=function(e){
    const isInside=drawer.contains(e.target);
    if(!isInside){
      drawerClose();
    }
  };
  // slight timeout so initial click doesn't immediately close
  setTimeout(()=>document.addEventListener('click',outsideClickHandler),0);
}}
function drawerClose(){const drawer=document.querySelector('.sidebar-element.hide-desktop');if(drawer){
  prepareTransition(drawer);
  drawer.classList.remove('open');
  document.body.classList.remove('drawer-open');

  // remove overlay
  if(overlayEl){
    overlayEl.parentNode.removeChild(overlayEl);
    overlayEl=null;
  }

  if(outsideClickHandler){
    document.removeEventListener('click',outsideClickHandler);
    outsideClickHandler=null;
  }
}}
